import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { get, put } from '../api/client.js';

export function useJhaTemplate() {
  return useQuery({
    queryKey: ['jha', 'template'],
    queryFn: async () => (await get('/api/jha/template')).template,
    staleTime: 60_000,
  });
}

export function useUpdateJhaTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) => put('/api/jha/template', body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['jha'] }),
  });
}
